import axios from 'axios'

// Vi skaber en beholder til vores cancel-token
export const axiosConfig = {
    cancelTokenSource: axios.CancelToken.source()
}

// Funktionen som din router skal kalde
export const cancelPendingRequests = () => {
    axiosConfig.cancelTokenSource.cancel('Operation canceled by router')
    axiosConfig.cancelTokenSource = axios.CancelToken.source()
}

const instance = axios.create({
    baseURL: process.env.API_URL,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
})

export default instance



// WEBPACK FOOTER //
// ./src/axios/index.js